import { motion } from 'framer-motion'
import { useLanguage } from '../../../contexts/LanguageContext'
import MobileSlideShell from './MobileSlideShell'
import { fadeScaleProps, M_CARD } from './mobileMotion'

const statMeta = [
  { value: 65, color: '#22A756' },
  { value: 30, color: '#1B2A6B' },
  { value: 90, color: '#22A756' },
]

export default function Slide5M() {
  const { t } = useLanguage()
  const s = t.slides.slide5

  return (
    <MobileSlideShell>
      <motion.h2
        {...fadeScaleProps(0)}
        className="text-center text-[24px] font-semibold leading-tight tracking-tight text-[#1B2A6B]"
      >
        {s.headline}
      </motion.h2>

      <div className="flex flex-col gap-5">
        {s.stats?.map((row, i) => (
          <motion.div
            key={i}
            {...fadeScaleProps(0.08 + i * 0.06)}
            className={`${M_CARD} flex flex-col items-center gap-2 text-center`}
          >
            <p className="text-[13px] font-semibold uppercase tracking-widest text-[#1B2A6B]/45">
              {s.prefix}
            </p>
            <p
              className="text-[44px] font-bold tabular-nums leading-none"
              style={{ color: statMeta[i]?.color ?? '#1B2A6B' }}
            >
              {statMeta[i]?.value ?? '—'}
              <span className="text-[60%]">%</span>
            </p>
            <p className="whitespace-pre-line text-[16px] leading-relaxed text-[#1B2A6B]/70">
              {row.label}
            </p>
          </motion.div>
        ))}
      </div>
    </MobileSlideShell>
  )
}
